import angular from "angular";

angular
    .module('app')
    .component('roleForm', {
        template: require('./role-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.name = null;
    $ctrl.label = null;

    $ctrl.$onInit = function () {
        if ($ctrl.resolve.role) {
            $ctrl.id = $ctrl.resolve.role.id;
            $ctrl.name = $ctrl.resolve.role.name;
            $ctrl.label = $ctrl.resolve.role.label;
        }
    };

    $ctrl.submit = function () {

        let req = null;

        let params = {name: $ctrl.name, label: $ctrl.label};

        $ctrl.loading = true;

        if ($ctrl.id) {
            params['_method'] = 'PUT';
            req = $http.post(`/admin/roles/${$ctrl.id}`, params);
        } else {
            req = $http.post('/admin/roles', params);
        }

        req.then(
            function (response) {
                if (!$ctrl.id) {
                    $ctrl.id = response.data.id;
                    Notifier.success('Роль успешно создан', 2);
                } else {
                    Notifier.success('Роль успешно обновлен', 2);
                }
                $ctrl.close({$value: {id: $ctrl.id, name: $ctrl.name, label: $ctrl.label}});
            },
            function (error) {
                $ctrl.loading = false;
                Notifier.error('Произошла ошибка', 2)
            }
        );
    };

}
